module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_5010.f26771cc.png";